import { DetailResponseData, ListResponseData } from "./base";
import { TagListItem } from "./tag";

export enum ContentBoxSectionEnum {
  PROFILE = "profile",
  EDUCATION = "education",
  CAREER = "job",
  COMMUNITY = "community",
}

export interface ContentBoxListItem {
  id: string;
  value: string;
  content_box_tags: TagListItem[];
}

export interface ContentBoxesResponseData extends ListResponseData<ContentBoxListItem> {}

export interface ContentBoxDetail extends ContentBoxListItem {}

export interface CreateContentBoxPayload {
  value: string;
  tags: string[];
}

export interface CreateContentBoxResponseData extends DetailResponseData<ContentBoxDetail> {}

export interface UpdateContentBoxPayload {
  value: string;
  tags: string[];
}

export interface UpdateContentBoxResponseData extends DetailResponseData<ContentBoxDetail> {}
